import React from "react";
import Page from "view/layout/page";

function Error404View() {
  return (
    <Page title="404 Not Found">
      <p>Sorry, that page does not exist.</p>
    </Page>
  );
}

export { Error404View };
